module.exports = __webpack_public_path__ + "static/media/boite-vege-modal.90c3ffbc.png";